/* C23 · Cost-per-cut — investment ÷ (cuts × 312 × years), plus a monthly amortisation.
   312 working days = honest 6-day week (v2.2 divergence, deliberate).
   Currency: Intl.NumberFormat with the cart's ISO code (data-currency) for the live values —
   symbol always matches the market, never hardcoded. Static min/max bounds are server | money. */
(() => {
  if (window.__jpCpcInit) return;
  window.__jpCpcInit = true;

  const init = (root) => {
    if (root.dataset.jpCpcReady) return;
    root.dataset.jpCpcReady = 'true';
    const currency = root.dataset.currency || 'GBP';
    const lang = document.documentElement.lang || 'en';
    const monthlyTpl = root.dataset.monthlyTpl || '';
    const price = root.querySelector('[data-cpc-price]');
    const cuts = root.querySelector('[data-cpc-cuts]');
    const years = root.querySelector('[data-cpc-years]');
    const outPrice = root.querySelector('[data-cpc-price-out]');
    const outCuts = root.querySelector('[data-cpc-cuts-out]');
    const outYears = root.querySelector('[data-cpc-years-out]');
    const result = root.querySelector('[data-cpc-result]');
    const monthlyEl = root.querySelector('[data-cpc-monthly]');
    if (!price || !cuts || !years || !result || !outCuts || !outYears) return;

    const money = (value, digits) => {
      const d = digits == null ? (value < 0.01 ? 3 : 2) : digits;
      try {
        return new Intl.NumberFormat(lang, {
          style: 'currency',
          currency,
          minimumFractionDigits: d,
          maximumFractionDigits: d,
        }).format(value);
      } catch {
        return value.toFixed(d);
      }
    };

    const update = () => {
      const p = parseInt(price.value, 10);
      const c = parseInt(cuts.value, 10);
      const y = parseInt(years.value, 10);
      if (outPrice) outPrice.textContent = money(p, 0);
      outCuts.textContent = c;
      outYears.textContent = y;
      /* human-readable slider values for screen readers (raw number alone lacks unit/currency context) */
      price.setAttribute('aria-valuetext', money(p, 0));
      cuts.setAttribute('aria-valuetext', (outCuts.closest('output')?.textContent || c).toString().trim());
      years.setAttribute('aria-valuetext', (outYears.closest('output')?.textContent || y).toString().trim());
      result.textContent = money(p / (c * 312 * y));
      if (monthlyEl && monthlyTpl) monthlyEl.textContent = monthlyTpl.replace('[monthly]', money(p / (y * 12), 2));
    };
    /* Visible number updates live on 'input'; the SR announcement is coalesced to 'change'
       (pointer release / keyboard step settle) so a drag doesn't queue many polite announcements. */
    const announce = () => {
      const sr = root.querySelector('[data-cpc-announce]');
      if (!sr) return;
      const label = (root.querySelector('.jp-cpc__result small')?.textContent || '').trim();
      sr.textContent = (label ? label + ': ' : '') + result.textContent +
        (monthlyEl && monthlyEl.textContent ? '. ' + monthlyEl.textContent : '');
    };
    [price, cuts, years].forEach((el) => {
      el.addEventListener('input', update);
      el.addEventListener('change', announce);
    });
    update();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-jp-cpc]').forEach(init);
  });
  /* Customiser re-renders replace section DOM — re-init fresh nodes */
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-jp-cpc]').forEach(init);
  });
})();
